import script from "./OptimizationHistoryComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./OptimizationHistoryComponent.vue?vue&type=script&setup=true&lang=js"

import "./OptimizationHistoryComponent.vue?vue&type=style&index=0&id=316c0bfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-316c0bfc"]])

export default __exports__